<template>
  <section class="modal-wrap active" v-if="isShow">
    <div class="overlay" @click="onClose"></div>
    <transition name="drop">
      <div class="modal">
        <div class="modal-bd">
          <h3 class="bd-tt">V5.7 震撼来袭了</h3>
          <p class="bd-txt txt--left">提示文案提示文案提示文案提示文案提示文案提示文案提示文案提示文案提示文案</p>
        </div>
        <footer class="modal-ft">
          <span class="ft-btn">取消</span>
          <span class="ft-btn">确定</span>
        </footer>

      </div>
    </transition>
  </section>
</template>

<script>
  export default {
    name: "modal",
    props: {

    },
    data() {
      return {
        show:false
      }
    },
    methods: {
      onClose() {
        this.$emit('on-close')
      }
    }
  }
</script>

<style scoped>
  .drop-enter-active {
    transition: all .5s;
  }
  .drop-leave-active {
    transition: all .3s;
  }
  .drop-enter {
    transform: translateY(-500px);
  }
  .drop-leave-active {
    transform: translateY(-500px);
  }
  .overlay {
    display: none;
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 4000;
  }

  .active .overlay, .overlay.active {
    display: block;
  }

  .dialog-wrap {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .dialog-overlay {
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 4001;
  }
  .dialog-outer{
    position: fixed;
    top: 50%;
    left: 0;
    right: 0;
    z-index: 4005;
    transform: translate(0,-50%);
  }
  .dialog {
    width: 280px;
    margin: auto;
    background: #fff;
    border-radius: 5px;
    overflow: hidden;
    -webkit-animation: b .3s 0ms ease both;
    animation: b .3s 0ms ease both;
  }
  @keyframes b {
    0% {
      opacity: 0;
      -webkit-transform: scale(.5);
    }
    100% {
      opacity: 1;
      -webkit-transform: scale(1);
    }
  }
  .dialog .dialog-hd {
    padding: 15px 15px;
    font-size: 18px;
    text-align: center;
  }
  .dialog .dialog-hd_min {
    font-size: 18px;
    text-align: center;
    padding: 15px 15px 10px;
  }
  .dialog .dialog-bd {
    position: relative;
    padding: 0 15px 15px;
    font-size: 14px;
    color: #666;
    max-height: 320px;
    overflow-y: auto;
    text-align: left;
  }

  .dialog .dialog-bd.dialog-bd_center {
    text-align: left;
  }

  .dialog .dialog-ft {
    overflow: hidden;
    text-align: center;
    line-height: 44px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }

  .dialog .dialog-ft .dialog-btn {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 1%;
  }

  .dialog .dialog-ft button {
    line-height: normal;
    height: 44px;
    border: none;
    background: transparent;
    border: none;
    outline: none;
  }

  .dialog .dialog-ft .dialog-btn {
    position: relative;
  }
  .dialog-btn_default{
    color: #353535;
    font-weight: 400;
  }
  .dialog-btn_primary{
    color: #09BB07;
    font-weight: 600;
  }

  .dialog .dialog-ft .dialog-btn::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    box-sizing: border-box;
    right: 0;
    height: 0;
    -webkit-transform: scaleY(0.5);
    -ms-transform: scaleY(0.5);
    transform: scaleY(0.5);
    border-top: 1px solid #dbdbdb;
  }

  .dialog .dialog-ft .dialog-btn:nth-of-type(1)::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    box-sizing: border-box;
    width: 0;
    bottom: 0;
    -webkit-transform: scaleX(0.5);
    -ms-transform: scaleX(0.5);
    transform: scaleX(0.5);
    border-left: 1px solid #dbdbdb;
    left: auto;
    right: 0;
  }

  .dialog .dialog-ft .dialog-btn:first-of-type {
    border-bottom-left-radius: 5px;
  }

  .dialog .dialog-ft .dialog-btn:last-of-type {
    border-bottom-right-radius: 5px;
  }

  .dialog .dialog-ft .dialog-btn:hover, .dialog .dialog-ft .dialog-btn:active {
    background: #f5f5f5;
  }

  .dialog .dialog-ft.dialog-ft_full {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .dialog .dialog-ft.dialog-ft_full .dialog-btn {
    width: 100%;
    border-left: none;
  }

  .dialog .dialog-ft.dialog-ft_full .dialog-btn:first-of-type::after {
    display: none;
  }

  .dialog .dialog-ft.dialog-ft_full .dialog-btn:first-of-type {
    border-bottom-left-radius: 0;
  }

  .dialog .dialog-ft.dialog-ft_full .dialog-btn:last-of-type {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/plugins/modal/modal.vue